import React, {useState, useEffect} from 'react';
import _ from 'lodash';
import {connect} from 'react-redux';
import {connectWithCore} from 'framework/hocs';
import REST from 'go/requests/rest';

export const SubAppReviewTaskListener = (props) => {
  const {entityId, token, permissions} = props;

  const [done, setDone] = useState(false);

  useEffect(() => {
    let getWorkflowTasksBody = {};
    if (!_.isEmpty(permissions)) {
      getWorkflowTasksBody.candidateGroups = permissions;
    }

    _.assign(getWorkflowTasksBody, {
      includeAssignedTasks: true,
      processVariables: [
        {
          name: 'entityId',
          value: entityId,
          operator: 'eq',
        },
      ],
      taskDefinitionKey: 'reviewSubapplication',
    });

    REST.workflow
      .getAllExternalEligibleTasks(token, '', getWorkflowTasksBody)
      .then((res) => {
        if (res.status === 200) {
          return res.json();
        }
      })
      .then((resJson) => {
        setDone(true);
        if (resJson[0])
          props.saveEntitySessionData('context.workflowTask.task.id', resJson[0].id);
      })
      .catch((err) => {
        console.log('Error getting tasks:');
      });
  }, []);

  return <>{null}</>;
};

export const mapStateToProps = (state) => {
  return {
    token: state.auth.token,
    permissions: state.auth.permissions,
  };
};

const connectedSubAppReviewTaskListener = connect(
  mapStateToProps,
  null
)(connectWithCore(SubAppReviewTaskListener));
export default connectedSubAppReviewTaskListener;
